var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDropUp = function SvgArrowDropUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-drop-up_svg__svg-icon",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "arrow-drop-up_svg__arrow-drop-up"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M8.71 12.29 11.3 9.7a.996.996 0 0 1 1.41 0l2.59 2.59c.63.63.18 1.71-.71 1.71H9.41c-.89 0-1.33-1.08-.7-1.71",
    className: "arrow-drop-up_svg__vector"
  }))));
};
export { SvgArrowDropUp as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAyNCAyNCIgY2xhc3M9InN2Zy1pY29uIiByb2xlPSJpbWciPjx0aXRsZT5BcnJvdyBEcm9wIFVwPC90aXRsZT48ZyBjbGFzcz0iYXJyb3ctZHJvcC11cCI+PHBhdGggZmlsbD0iY3VycmVudENvbG9yIiBkPSJNOC43MSAxMi4yOSAxMS4zIDkuN2EuOTk2Ljk5NiAwIDAgMSAxLjQxIDBsMi41OSAyLjU5Yy42My42My4xOCAxLjcxLS43MSAxLjcxSDkuNDFjLS44OSAwLTEuMzMtMS4wOC0uNy0xLjcxWiIgY2xhc3M9InZlY3RvciIvPjwvZz48L3N2Zz4=";